import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Building2 } from 'lucide-react';

const Footer: React.FC = () => {
  const footerLinks = [
    { label: 'Despre Noi', href: '/despre-solyra' },
    { label: 'Termeni și condiții', href: '/termeni-conditii' },
    { label: 'Politica de confidențialitate (GDPR)', href: '/politica-confidentialitate' },
    { label: 'Politica cookie', href: '/politica-cookie' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <footer className="bg-background border-t border-border py-10">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Links */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 mb-8">
          {footerLinks.map((link, index) => (
            <React.Fragment key={link.href}>
              {index > 0 && <span className="hidden sm:inline text-muted-foreground">•</span>}
              <Link
                to={link.href}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {link.label}
              </Link>
            </React.Fragment>
          ))}
        </div>

        {/* Company info + Netopia */}
        <div className="border-t border-border pt-6 grid gap-6 md:grid-cols-3 items-start text-xs text-muted-foreground">
          {/* Company identity */}
          <div className="space-y-1.5">
            <p className="flex items-center gap-2 font-semibold text-foreground">
              <Building2 className="h-3.5 w-3.5" />
              Solyra SRL
            </p>
            <p>CUI: 48381732</p>
            <p className="flex items-center gap-2">
              <MapPin className="h-3.5 w-3.5 flex-shrink-0" />
              Târgu Mureș, jud. Mureș
            </p>
          </div>

          {/* Contact */}
          <div className="space-y-1.5">
            <p className="font-semibold text-foreground">Contact</p>
            <p className="flex items-center gap-2">
              <Phone className="h-3.5 w-3.5 flex-shrink-0" />
              <a href="tel:+40750434807" className="hover:text-foreground transition-colors">
                0750 434 807
              </a>
            </p>
            <p className="flex items-center gap-2">
              <Mail className="h-3.5 w-3.5 flex-shrink-0" />
              <a href="mailto:contact@solyra.ro" className="hover:text-foreground transition-colors">
                contact@solyra.ro
              </a>
            </p>
          </div>

          {/* Payments + ANPC */}
          <div className="space-y-2 md:text-right">
            <p className="font-semibold text-foreground">Plăți securizate</p>
            <div id="netopia-logo" className="flex md:justify-end" />
            <p>
              <a
                href="https://anpc.ro/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-foreground transition-colors"
              >
                ANPC – Protecția Consumatorilor
              </a>
            </p>
          </div>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-8">
          © 2026 Solyra SRL. Toate drepturile rezervate.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
